var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Uni-Course-Version-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Uni-Course---All",
    transform: "translate(-636.000000, -346.000000)",
    fill: "#4B4E6A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(636.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Search",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.87647552,8.44501017 C1.87647552,4.82348205 4.82304688,1.87647552 8.44501017,1.87647552 C12.0669735,1.87647552 15.0131097,4.82348205 15.0131097,8.44501017 C15.0131097,12.0665383 12.0669735,15.0131097 8.44501017,15.0131097 C4.82304688,15.0131097 1.87647552,12.0665383 1.87647552,8.44501017 M19.7251869,18.3974673 L15.0370443,13.7093247 C16.1933048,12.264543 16.8900203,10.4355016 16.8900203,8.44501017 C16.8900203,3.78820022 13.1013849,5.32907052e-15 8.44501017,5.32907052e-15 C3.7886354,5.32907052e-15 0,3.78820022 0,8.44501017 C0,13.1018201 3.7886354,16.8900203 8.44501017,16.8900203 C10.4363719,16.8900203 12.2649782,16.19374 13.7101951,15.0361739 L18.3983376,19.7243165 C18.5815464,19.9075253 18.8213279,19.9993472 19.0615447,19.9993472 C19.3017614,19.9993472 19.5419781,19.9075253 19.7251869,19.7243165 C20.0916044,19.357899 20.0916044,18.7638848 19.7251869,18.3974673"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/Icon-Search.f0361784f105407e3f99a7320c3dcfb8.svg";
export { ForwardRef as ReactComponent };